export default __webpack_public_path__ + "static/media/office.a46c0a7b.svg";